<template>
    <div class="theme-main">
        <div class="theme-footer-list" v-for="(item, index) in lists" :key="index" :class="!(index%3)?'theme-footer-list-0':''" @click='gotodetail(item)'>

            <div class="theme-footer-top">
                <img :src="item.thumbnail" alt="">
                <!-- <div class="small-pop"></div> -->
                <div class="line">主推路线</div>
            </div>
            <div class="theme-list-tag">
                <p v-for="(tagItem, tagIndex) in item.topTags" :key="tagIndex">{{tagItem}}</p>
            </div>
            <div class="theme-footer-bottom">
                <div class="classes">{{item.classes}}</div>
                <p class="theme-footer-main-title">{{item.title}}</p>
                <div class="theme-footer-main-time">
                    <svg-icon icon-class="time"></svg-icon>
                    旅行时间:{{item.time}}
                </div>
                <div class="theme-user-tag">
                    <p v-for="(tagItem, tagIndex) in item.bottomTags" :key="tagIndex">{{tagItem}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    lists: {
      default: () => {
        return []
      },
      type: Array,
      required: true
    }
  },
  inject: ['reload'],
  methods: {
    gotodetail (item) {
      this.$router.push({
        path: '/routeDetail',
        query: {
          id: item.id,
          img: item.thumbnail
        }
      })
      this.reload()
    }
  }
}
</script>

<style lang="scss">
.theme-main {
    width: 1232px;
    display: flex;
    flex-flow:row wrap;
    margin: 0 auto;
}
.theme-footer-list {
    margin-top: 20px;
    margin-left: 23px;
    width: 395px;
    // height: 413px;
    overflow: hidden;
    cursor: pointer;
    position: relative;

    .theme-footer-top {
        width: 395px;
        height: 267px;
        position: relative;
        overflow: hidden;
        .small-pop{
            width:100%;
            height:100%;
            background: rgba(0,0,0,0.4);
            // opacity: 40%;
            position:absolute;
            left: 0;
            top: 0;
        }
    }
    img {
        width:100%;
        height:100%;
        transform: scale(1);
        transition: transform 0.5s;
    }
    .line {
        background: #ff9900;
        width: 84px;
        height: 32px;
        font-size: 14px;
        font-weight:300;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1000;
        transform-origin: 0 0
    }
    &:hover {
        box-shadow: 0px 0px 12px #ccc9c9;
        transition: all 0.2s;
        img {
            transform: scale(1.02);
            transition: all 0.5s;
        }
        .theme-footer-top .small-pop{
            transition: all 0.3s;
            background: rgba(0,0,0,0)
        }
        .theme-list-tag{
            transition: all 0.3s;
            background: rgba(0,0,0,0.7)
        }
    }
}
.theme-footer-list-0 {
    margin-left: 0;
}
.theme-list-tag{
    position: absolute;
    top: 0;
    left: 0;
    padding-bottom: 10px;
    background: rgba(0, 0, 0, 0.2);
    z-index: 1000;
    display: flex;
    p {
        font-size: 14px;
        color: #fff;
        font-weight: 300;
        padding: 0px 13px;
        line-height: 1;
        margin-top: 10px;
        border-right: 1px solid #fff;
        &:last-child {
            border: none;
        }
    }
}
.theme-footer-bottom {
    border: 1px solid #e8e8e8;
    line-height: 1;
    overflow: hidden;
    .classes {
        color: #ff9900;
        font-size: 14px;
        margin: 18px 13px 8px 15px;
        // text-indent: 4px;
        // font-style:italic;
    }
    .theme-footer-main-title {
        color: #434343;
        font-size: 18px;
        font-weight: bold;
        margin: 0 13px 10px 15px;
    }
    .theme-footer-main-time {
        font-size: 14px;
        color: #7a7a7a;
        margin: 0 13px;
        display: flex;
        align-items: center;
        svg {
            font-size: 17px;
            margin-right: 5px;
        }
    }
    .theme-user-tag {
        display: flex;
        margin: 20px 15px;
        p {
            color: #3399ff;
            font-size: 12px;
            border: 1px solid #3399ff;
            padding: 7px 10px;
            border-radius: 2px;
            margin-right: 10px;
            // font-style: italic;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ListsContent.vue